const handleDownload = (props) => {
    const { token, host, name, uris, repos, endpoint, method } = props;
    const iframe = document.createElement('iframe');
    iframe.setAttribute('data-type', 'download-iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;
    const form = iframeDocument.createElement('form');
    form.rel = 'noopener noreferrer';
    form.method = method;
    form.action = `${host}/${endpoint}`;
    form.addEventListener('submit', (event) => {
        event.preventDefault();
        document.body.removeChild(iframe);
    });
    iframeDocument.body.appendChild(form);
    const addFormInput = (_name, value) => {
        const hiddenField = iframeDocument.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = _name;
        hiddenField.value = value;
        form.appendChild(hiddenField);
    };
    token && addFormInput('NWB', token);
    name && addFormInput('name', name);
    repos &&
        repos.forEach((repo) => {
            addFormInput('repositoryPath', repo);
        });
    uris &&
        uris.forEach((uri) => {
            addFormInput('uri', uri);
        });
    form.submit();
};
const download = (props) => handleDownload(props);
export default download;
